/**
 * drawerTypeを決めるmixin
 */

import { actions, drawerType } from '@/vuex/modules/ui/drawer/constants'

export const setDrawerTypeLoginLp = {
  created() {
    const type = drawerType.LOGIN_LP_DRAWER
    this.$store.dispatch(actions.CHANGE_DRAWER_TYPE, { type })
  },
}
